import { addSourceToVideo } from "./helpers";

export const videoThumbnail = () => {
  const thumbnails = document.querySelectorAll<HTMLElement>(
    "[js-video-thumbnail]"
  );

  if (thumbnails.length < 1) {
    return;
  }

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener("click", () => {
      showVideo(thumbnail);
    });
  });
};

export const showVideo = (thumbnail: HTMLElement) => {
  /* Hide thumbnail */
  thumbnail.classList.add("hidden");

  /* Check sibling is a video */
  const video = thumbnail.nextElementSibling as HTMLVideoElement;

  if (!video || video.tagName !== "VIDEO") {
    return;
  }

  /* Show video and play */
  if (video.dataset.videoSrc) {
    addSourceToVideo(video, video.dataset.videoSrc);
  }
  video.classList.remove("hidden");
  video.play();
};
